import { createI18n } from "vue-i18n";
import { buildMessages } from "@shared/app/i18n/helpers";
import { CONFIG } from "@shared/config";
import { DateFormat, NumberFormat } from "@shared/app/i18n/constants";

const {
  application: {
    initialization: {
      localization: {
        language: { supported, defaultValue: defaultLocale },
      },
    },
  },
} = CONFIG;

export const datetimeFormats: Record<
  string,
  Record<string, Intl.DateTimeFormatOptions>
> = supported.reduce((obj, lang) => {
  // Overwrite where needed, these are defaults.
  return {
    ...obj,
    [lang]: {
      [DateFormat.LONG]: {
        dateStyle: "long",
      },
      [DateFormat.LONG_WITH_TIME]: {
        dateStyle: "long",
        timeStyle: "short",
      },
      [DateFormat.TWELVE_HOUR]: {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      },
      [DateFormat.TWENTY_FOUR_HOUR]: {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      },
    },
  };
}, {});

export const numberFormats: Record<
  string,
  Record<string, Intl.NumberFormatOptions>
> = supported.reduce((obj, lang) => {
  // Overwrite where needed, these are defaults.
  return {
    ...obj,
    [lang]: {
      [NumberFormat.PERCENTAGE]: {
        style: "unit",
        unit: "percent",
        maximumFractionDigits: 1,
      },
      [NumberFormat.KILOWATT]: {
        notation: "standard",
        maximumFractionDigits: 2,
      },
      [NumberFormat.UNIT]: {
        style: "unit",
        maximumFractionDigits: 1,
      },
      [NumberFormat.CURRENCY]: {
        style: "currency",
      },
      [NumberFormat.INTEGER]: {
        notation: "compact",
        compactDisplay: "short",
        maximumFractionDigits: 0,
      },
    },
  };
}, {});

const fallbackLocale = {
  "es-MX": ["es-ES"],
  "en-NL": ["en-US"],
  "en-NO": ["en-US"],
  "en-DE": ["en-US"],
  "en-FI": ["en-US"],
  "en-GB": ["en-US"],
  "en-FR": ["en-US"],
  "nl-BE": ["nl-NL"],
  "de-CH": ["de-DE"],
  "fr-CH": ["fr-FR"],
  "it-CH": ["it-IT"],
  default: [defaultLocale, "en-US"],
};

export const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  messages: {},
  formatFallbackMessages: true,
  numberFormats,
  datetimeFormats,
  fallbackLocale,
});

await buildMessages(fallbackLocale).then((messages) => {
  for (const key in messages) {
    i18n.global.setLocaleMessage(key, messages[key]);
  }
});
